import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CxNumericPipe } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import {
  CounterInputModule,
  DetailedStockInfoModule,
  DropdownModule,
  PipesModule,
  PrincipalConfigurationDirectiveModule,
  ScreenSizeModule,
  SpinnerModule,
} from '../../../../shared';
import { AddToAreaOfUseModule } from '../../../../shared/components/add-to-area-of-use';
import { AddToOrderCardModule } from '../../../../shared/components/add-to-order-card/add-to-order-card.module';
import { AddToShoppingListModule } from '../../../../shared/components/add-to-shopping-list/add-to-shopping-list.module';
import { ArticlePriceModule } from '../../../../shared/components/article-price/article-price.module';
import { PdpListVariantsModalModule } from '../pdp-list-variants-modal/pdp-list-variants-modal.module';
import { PickerAttributeModule } from '../picker-attribute';
import { PdpSkuPickerComponent } from './pdp-sku-picker.component';

@NgModule({
  declarations: [PdpSkuPickerComponent],
  exports: [PdpSkuPickerComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    ReactiveFormsModule,
    CounterInputModule,
    PipesModule,
    AddToShoppingListModule,
    DropdownModule,
    PickerAttributeModule,
    AddToOrderCardModule,
    PrincipalConfigurationDirectiveModule,
    DetailedStockInfoModule,
    PdpListVariantsModalModule,
    AddToAreaOfUseModule,
    ArticlePriceModule,
    ScreenSizeModule,
    SpinnerModule,
    NgbTooltipModule,
  ],
  providers: [CxNumericPipe],
})
export class PdpSkuPickerModule {}
